import React from 'react';
import { IFormData, IDocumentInput } from '@homeporter/types';
import {
  Box,
  Typography,
  Checkbox,
  TextField,
  FormControlLabel,
} from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

const useFormStyles = () => {
  return {
    formItem: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '2rem',
    },
    formInputContainer: {
      marginLeft: '1rem',
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    formInput: {
      mr: '4rem',
      '& .MuiInputBase-root': {
        fontSize: '0.875rem',
      },
      '& input': {
        minWidth: '3rem',
        maxWidth: '30rem',
      },
    },
  };
};

const FormView: React.FC<{ data?: IFormData[] | null }> = ({ data }) => {
  const styles = useFormStyles();
  if (!data) return null;

  console.log('::::data:', data);
  return (
    <ThemeProvider theme={theme}>
      {data.map((sectionEntry, sectionIndex) => (
        <Box
          sx={{ paddingLeft: '1rem', mb: '2rem' }}
          key={sectionEntry.title || sectionIndex}>
          <h2 style={{ margin: '.5rem 0' }}>{sectionEntry.title}</h2>
          {sectionEntry.description && (
            <Typography style={{ margin: '.5rem 0' }}>
              {sectionEntry.description}
            </Typography>
          )}
          {sectionEntry.children.map((child, childIndex) => (
            <Box
              sx={{ pl: '1rem', pb: '.5rem' }}
              key={child.subtitle || childIndex}>
              <h4 style={{ margin: '.5rem 0' }}>{child.subtitle}</h4>
              {child.description && (
                <Typography style={{ margin: '.5rem 0' }}>
                  {child.description}
                </Typography>
              )}
              {child.items.map((item: IDocumentInput, idx: number) => (
                <Box sx={styles.formItem} key={idx}>
                  {item.type === 'boolean' && <Checkbox />}
                  {item.label && (
                    <Typography style={{ margin: 0 }}>{item.label}</Typography>
                  )}
                  {item.type !== 'boolean' && (
                    <Box
                      sx={{
                        ...styles.formInputContainer,
                        margin:
                          item.type === 'string'
                            ? '.25rem 0 .25rem .75rem'
                            : '0 0 0 .75rem',
                      }}>
                      {Array.isArray(item.type) ? (
                        item.type.map((option, i) => (
                          <FormControlLabel
                            key={i}
                            control={<Checkbox />}
                            label={option}
                          />
                        ))
                      ) : item.type === 'string' ? (
                        <TextField
                          size="small"
                          variant="outlined"
                          fullWidth
                          sx={styles.formInput}
                        />
                      ) : (
                        <></>
                      )}
                    </Box>
                  )}
                </Box>
              ))}
            </Box>
          ))}
        </Box>
      ))}
    </ThemeProvider>
  );
};

export default FormView;
